export default "__VITE_ASSET__5wfdxoiB__"